const defaultErrorContext = { enabled: true, level: 'error' };
export class WidgetError extends Error {
    constructor(message, contexts) {
        super(message);
        this.message = message;
        this.contexts = { widgetError: contexts };
    }
}
function isErrorContext(value) {
    return !!(value && value.contexts);
}
export function handleError(message, context) {
    let errorContext;
    if (!isErrorContext(context)) {
        errorContext = Object.assign(Object.assign({}, defaultErrorContext), { contexts: { context } });
    }
    else {
        errorContext = Object.assign(Object.assign({}, defaultErrorContext), context);
    }
    const tracker = globalThis.TrackerService;
    if (errorContext.enabled && tracker) {
        tracker.captureMessage(message, errorContext.level, errorContext.contexts);
    }
    if (errorContext.level === 'error') {
        const unwrappedContext = errorContext.contexts ? Object.values(errorContext.contexts) : [];
        console.error(message, ...unwrappedContext);
    }
    else {
        console.warn(message, errorContext.contexts);
    }
}
